<script setup>
import {computed, watch} from "vue";
import {useStore} from "vuex";
import useDates from "@/composables/useDates";
import SelectInput from "@/components/global-themed/inputs/SelectInput.vue";

const props = defineProps({
  column: {
    type: Number,
    required: true,
  }
})

const dates = useDates();

const store = useStore();

const competitors = computed(() => store.getters['competitionV2/competitors']);

const selectedCompetitor = computed(() => store.getters['competitionV2/compareCompetitors'][props.column - 1]);

watch(selectedCompetitor, () => {
  store.dispatch('competitionV2/fetchCompetitorCompareData', props.column)
}, {immediate: true})

const changeCompetitor = (event) => {
  const selectedId = event.target.value;
  if (!selectedId) {
    store.dispatch('competitionV2/setCompareCompetitor', {
      column: props.column,
      competitor: undefined,
    });
    return;
  }

  const newSelectedCompetitor = competitors.value.find(competitor => competitor.id.toString() === selectedId);
  store.dispatch('competitionV2/setCompareCompetitor', {
    column: props.column,
    competitor: newSelectedCompetitor,
  });
}

const clear = () => {
  store.dispatch('competitionV2/setCompareCompetitor', {
    column: props.column,
    competitor: undefined,
  })
}

</script>

<template>
  <div class="tw-w-full">
    <SelectInput
      v-if="!selectedCompetitor"
      id="competitor"
      class="tw-text-sm"
      @change="changeCompetitor"
    >
      <template #default>
        <option
          :value="undefined"
        >
          Select competitor
        </option>
        <option
          v-for="competitor in competitors"
          :key="competitor.id"
          :value="competitor.id"
          :selected="selectedCompetitor?.id === competitor.id"
        >
          {{ competitor.simpleUrl }}
        </option>
      </template>
    </SelectInput>

    <div
      v-if="selectedCompetitor"
      class="tw-text-center tw-flex tw-flex-col tw-justify-center"
    >
      <button
        type="button"
        class="tw-bg-blue tw-text-white tw-rounded-xl tw-py-1 tw-px-3 tw-w-auto tw-flex tw-gap-2 tw-items-center tw-justify-center tw-mx-auto"
        @click.prevent="clear"
      >
        <span>{{ selectedCompetitor.simpleUrl }}</span>
        <svg-vue
          icon="icons/close"
          class="tw-h-2 tw-w-2 tw-text-white"
        />
      </button>

      <div class="tw-text-grey">
        Audited {{ selectedCompetitor.lastAuditedAt ? dates.formattedDate(selectedCompetitor.lastAuditedAt) : 'never' }}
      </div>
    </div>
  </div>
</template>
